<div class="page-container">
  <app-toolbar [title]="'COMMON.CALLS' | translate"></app-toolbar>
  <div class="page">
    <div class="wrapper">
      <div class="left">
        <div class="past">
          @if (pastCalls$ | async; as query) {
            @if (query.result$ | async; as result) {
              @if (result.isLoading) {
                <app-spinner></app-spinner>
              } @else if (result.isSuccess) {
                <app-call-list
                  #pastCallList
                  [calls]="getAllCalls(result.data!)"
                  [hasMore]="result.data!.pages.at(-1)?.hasMore ?? false"
                  [isFetchingNextPage]="result.isLoading || result.isFetchingNextPage"
                  [callListType]="'past'"
                  [useGroupingByDate]="true"
                  (fetchNextPage)="result.fetchNextPage()"
                  (hoverCall)="prefetchCall($event)"
                  (callGotIntoView)="setPastCallQueryParameter($event)"
                ></app-call-list>
              }
            }
          }
        </div>
      </div>
      <div class="right">
        <div class="upcoming">
          @if (upcomingCallsQuery.result$ | async; as result) {
            @if (result.isLoading) {
              <app-spinner></app-spinner>
            } @else if (result.isSuccess) {
              <app-call-list
                #upcomingCallList
                [calls]="getAllCalls(result.data!)"
                [hasMore]="result.data!.pages.at(-1)?.hasMore ?? false"
                [isFetchingNextPage]="result.isFetchingNextPage"
                [callListType]="'upcoming'"
                [useGroupingByDate]="true"
                (fetchNextPage)="result.fetchNextPage()"
                (hoverCall)="prefetchCall($event)"
                (callGotIntoView)="setUpcomingCallQueryParameter($event)"
              ></app-call-list>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
